import { styled } from "styled-components";

import { colorCSS, fontSizes, radius, shadow } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const Integration = styled.div`
    ${redundantCssFromKebab("background-color", `${colorCSS("N10")}`)}
    ${redundantCssFromKebab("border-radius", `${radius.button}`)}
    ${redundantCssFromKebab("box-shadow", `${shadow["normal"]}`)}
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("flex-direction", "column")}
    ${redundantCssFromKebab("height", "100%")}
    ${redundantCssFromKebab("text-align", "left")}
    ${redundantCssFromKebab("width", "100%")}
`;

export const Content = styled.div`
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("flex-direction", "column")}
    ${redundantCssFromKebab("flex-grow", "1")}
    ${redundantCssFromKebab("gap", "1rem")}
    ${redundantCssFromKebab("padding", "1rem")}
`;

export const LogoTitle = styled.div`
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("align-items", "start")}
    ${redundantCssFromKebab("gap", "1rem")}

    img,
    picture {
        ${redundantCssFromKebab("display", "block")}
        ${redundantCssFromKebab("min-width", "2.5rem")}
        ${redundantCssFromKebab("max-width", "2.5rem")}
        ${redundantCssFromKebab("height", "auto")}
    }

    h3 {
        ${redundantCssFromKebab("font-size", `${fontSizes.md}`)}
        ${redundantCssFromKebab("line-height", "1.5rem")}
        ${redundantCssFromKebab("margin", "0.25rem 0 0")}
    }
`;

export const Description = styled.p`
    ${redundantCssFromKebab("color", `${colorCSS("N400")}`)}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("margin", "0")}
`;

export const ButtonWrapper = styled.div`
    ${redundantCssFromKebab("margin-top", "auto")}
`;

export const FeaturedImage = styled.div<{ url?: string }>`
    ${redundantCssFromKebab(
        "border-radius",
        `${radius.button} ${radius.button} 0 0`
    )}
    ${redundantCssFromKebab("height", "0")}
    ${redundantCssFromKebab("padding-bottom", "92.7203%")}
    ${({ url }) =>
        url
            ? `
    background-image: url(${url});
    background-size: cover;
  `
            : `
    background-color: ${colorCSS("N50")};
  `}
`;
